import React from 'react';
import SectionHeader from './SectionHeader';
import TextInput from './TextInput';
import ChoiceRadio from './ChoiceRadio';
import NotesInput from './NotesInput';

/**
 * The spouse gate. Answering Yes reveals a second set of steps covering the
 * same ground for the client's spouse or partner.
 */
export default function StepHousehold({ number, data, onChange }) {
  const d = data || {};
  const update = (field) => (value) => onChange({ ...d, [field]: value });

  return (
    <div>
      <SectionHeader
        number={number}
        title="About You"
        tip="Your answer here decides whether we also collect details for a spouse or partner."
      />

      <ChoiceRadio
        id="household-has-spouse"
        inline
        label={<>Do you have a spouse or partner? <span className="text-danger">*</span></>}
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        value={d.has_spouse}
        onChange={update('has_spouse')}
      />

      {d.has_spouse === 'yes' && (
        <>
          <div className="row g-3">
            <TextInput
              id="household-spouse-name"
              label="Their name"
              col="col-md-6"
              value={d.spouse_name}
              onChange={update('spouse_name')}
              autoComplete="off"
            />
          </div>
          <div className="alert alert-light border-start border-4 border-danger mt-3 py-2 small">
            <i className="bi bi-info-circle me-2 text-danger" />
            We will ask for the same contact, employment, compliance, trusted
            contact and beneficiary details for them after we finish yours.
          </div>
        </>
      )}

      <NotesInput
        value={d.notes}
        onChange={update('notes')}
        label="Anything else about your household we should know?"
        placeholder="Optional"
      />
    </div>
  );
}
